module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "chapterheader",
    attrs: {
      "id": "toc_marker-2-11"
    }
  }, [_c('span', {
    staticClass: "chapterheader1"
  }, [_vm._v("Chapter 11")])])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I’m changing the subject, but have you seen Carl? He’s agreed to go to Green Bay with us, by the way.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Good. I saw him at a luncheon recently, but we didn’t discuss anything personal. I think he’s got a lot on his mind with work right now.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("I nodded. “Yes, Lynn has mentioned that there may be some problem with embezzlement.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I’m sure that stress is not helping their marriage.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I wonder if he’s seeing anyone,” I said, not expecting a response.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“You know, when a person is stressed, they may do things they wouldn’t ordinarily do,” Marc offered. “I know he was always crazy about Lynn, but things happen.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("We were interrupted when the waiter brought the Greek salads we ordered. We ordered beef Wellington as our main course. I was beginning to realize that Marc was somewhat of a foodie. ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Sometimes I miss cooking,” I admitted. “It’s too much trouble for one person, and living on The Hill, everyone wants to go to one of the many eateries in the neighborhood.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“You can’t blame them.” Marc grinned. “They are romantic and intimate, for the most part. A beautiful woman, a good bottle of wine, and some pasta is pretty hard to beat.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("I smiled. “I do make a pretty good red sauce. I thought it would be great to master the art of breadmaking, but not with such great bakeries on every street corner.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I’ll tell you what, I’ll bring bread from one of those bakeries if you make your sauce and pasta.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Really? My winters will be long and boring, but would you mind making the drive?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“In a snowstorm, perhaps not, but otherwise, I have no problem with it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“It’s a deal,” I said, patting his hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“More wine?” the waiter asked. “You may want to stay for a while. Our first snow of the year has arrived and it’s coming down pretty heavily.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Oh,” I said, feeling concerned for Marc. I looked out a nearby window, and it was a beautiful sight.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Would you like to take a walk when we leave? I see you are wearing boots, and I think it could be rather romantic.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("His question surprised me. “You are a romantic, aren’t you?” I teased. “I’m a softy and somewhat of a romantic myself, so I’m game.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Here’s the check,” the waiter said as he handed it to Marc. “Will there be anything else?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Yes.” He nodded. “How about getting us a couple of hot coffees to go?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Sure! Do you prefer regular or decaf?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Make it black and regular,” Marc instructed. “We won’t want to miss a thing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v(" We laughed.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Do you have gloves?” Marc asked, squeezing my hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Yes, plus a scarf and a warm coat.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("I could tell that Marc was pleased to hear I was game. We got up to leave, and I couldn’t help but notice the very generous tip that he left for the waiter. We took a deep breath as we wrapped our scarves tightly around our necks. It was like walking into a snow globe.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“This is exhilarating!” I said as I extended my hands to catch the snowflakes on my gloves. “I’m glad there isn’t any wind. It’s like someone is dropping a feather pillow on top of us.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("Marc laughed. “Hold onto my arm,” he suggested as we crossed the street. “I don’t want you to fall after you agreed to be so brave.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“My first snow in wine country,” I announced. “I never thought it would be so lovely.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Too bad you don’t have a fireplace in that house of yours. That would be perfect on a night like this.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I know. Every house should have one, especially an old house like mine. I would love to buy a gas fireplace for my upper porch, but I have other financial demands right now.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Hmmm,” Marc said as he put one hand on his chin. “You know, Christmas is coming, and I have been wondering what to give you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“You have?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Would you allow me to buy you one of those fireplaces for Christmas?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("I was shocked and stopped in my tracks.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Marc, you must have had too much wine. I couldn’t possibly let you do that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I’m serious. I know it’s something useful that you would enjoy, and if I’m lucky, I’ll get to enjoy it, too! You can pick it out, and once you do, I’ll put it on my charge. It’s that easy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("Suddenly, a car drove by at a fast pace and honked for us to get out of the way. We ran across the street and onto the curb.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I can’t let you do that.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“You can’t or won’t? There’s a difference. I really like you. Can’t you tell?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("I blushed. “You are so sweet, Marc,” I said as we continued walking. “I don’t deserve a friend like you.” If it was cold outside, I sure didn’t notice. He was warming my heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Is that a yes?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("We stopped walking again. ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Look, I’m not asking you to marry me. I just want to get you a nice Christmas gift!”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Okay, okay,” I said, feeling weak and selfish. “I could pay you back one day.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“It’s a gift, sweetheart,” he said, taking my gloved hand and lifting it to his lips. ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("Despite the fabric between my skin and his lips, I felt a surge of electricity run through me, completely taking me by surprise. “Now that’s romantic!” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext1"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1285f3e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Lily_Girl_split14.vue
// module id = 102
// module chunks = 0